export default "__VITE_ASSET__BHbXKJl5__"